import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Row, Col, Input, Form, Modal } from "antd";
import { path, equals } from "ramda";

import ContentBox from "../../components/layout/ContentBox";
import { ColumnLabel } from "../../components/text/OText";
import OForm from "../../components/form/OForm";
import { ColorInput } from "../../components/form/Input";
import { ColorLists } from "../../theme";
import { ColorSelection, OButton, ColorSquare } from "../../components/button";
import I18n from "../../i18n";
import store, { ReducerKeys } from "../../reducers/";
import { editOrganization, uploadOrganizationBanner } from "../../actions/OrganizationAction";
import { isAlive } from "../../util";
import UploadImage from "../../components/layout/UploadImage";
import { ContainerLoading } from "../../components/loading/PersistGateLoading";

class AppearancePanel extends React.Component{
    _lastUpdateOrganization = null;
    state = {
    	color:"",
    	name:"",
    	bannerSRC:"",
    	isLoading: false,
    };
    inputs = {
    	colorInput: undefined,
    	uploadImageInput: undefined,
    }
    /**
     * Form field that relate to organization field in store.
     */
    FormFields = {
    	NAME:"name", COLOR:"color"
    }
    constructor(props){
    	super(props);
    	this._lastUpdateOrganization = props.organization;
    	const { name, color } = this._lastUpdateOrganization;
    	this.state = { color, name, bannerSRC: path(["images","banner"], this._lastUpdateOrganization)};
    }
    componentWillReceiveProps(props){
    	const { organization } = props;
    	if(equals(this._lastUpdateOrganization, organization)){
    		let { color, name } = props.form.getFieldsValue([this.FormFields.NAME, this.FormFields.COLOR]);
    		color = color.replace("#","");
    		this.setState({ color:`#${color}`, name });
    	}else{
    		this._lastUpdateOrganization = organization;
    		const { name, color } = this._lastUpdateOrganization;
    		this.setState({
    			color, name, bannerSRC: path(["images","banner"], this._lastUpdateOrganization)
    		});
    	}
    }

    componentWillUnmount(){
    	this.context.clearPreviewTheme();
    }
    uploadBanner(bannerURI, onDone){
    	uploadOrganizationBanner(bannerURI).then(onDone).catch(error=>{
    		console.log("uploadOrganizationBanner with error:",error);
    		Modal.error({
    			title:I18n.t("logo_upload.upload_fail.title"), 
    			content:I18n.t("logo_upload.upload_fail.message")
    		});
    	});
    }

    updateOrganize({name, color}){
    	editOrganization({name, color}).then(res=>{
    		this.setState({isLoading:false});   
    	}).catch(error=>{
    		this.setState({isLoading:false});
    	});
    }

    getAppearanceDataFromStore(){
    	return path([ReducerKeys.ORGANIZATION, "organization"], store.getState());
    }
    onImageFileLoaded(file){
    	this.setState({bannerSRC: file});
    }
    onColorSelected(color){
    	const hexWithoutSharp = color.replace("#","");
    	this.props.form.setFieldsValue({[this.FormFields.COLOR]: color});
    	this.context.updatePreviewTheme({mainColor:color});
    	// this.setState({color},()=>{});
    }
    onPreviewPress(){
    	if(isAlive(this.state.color)){
    		this.context.updatePreviewTheme({mainColor:this.state.color});
    	}
    }
    onCustomColorChanged(event){
    	const code = event.target.value;
    	this.props.form.setFieldsValue({[this.FormFields.COLOR]: code});
    	// console.log('onCustomColorChanged.code: ',code);
    	this.setState({color:`#${code}`});
    }
    onNameChanged(event){
    	this.setState({name: event.target.value});
    }
    onSavePress(){
    	this.props.form.validateFields((err,values)=>{
    		if(err===null){
    			this.setState({isLoading: true});
    			const bannerURI = this.inputs.uploadImageInput.getImageURI();
    			// console.log('onSavePress.state',this.state);
    			const {name,color} = this.state;
    			if(bannerURI===null){
    				this.updateOrganize({name,color});
    			}else{
    				this.uploadBanner(bannerURI, (res)=>{
    					this.updateOrganize({name,color});
    				});
    			}
    		}
    	});
    }
    onCancelPress(){
    	const organize = this.getAppearanceDataFromStore();
    	const { name, color } = organize;
    	const banner = path(["images","banner"], organize);
    	this.props.form.setFieldsValue({
    		name,
    		color: color.replace("#","")
    	});
    	this.inputs.uploadImageInput.setImageSRC(banner);
    	this.setState({name, color, bannerSRC: banner});
    	this.context.clearPreviewTheme();
    }
    render(){
    	// console.log('appearance.state = ',this.state);
    	const noSharpColor = this.state.color;//.replace('#','');
    	const { getFieldDecorator } = this.props.form;
    	return (
    		<ContentBox.Box>
    			<ContentBox.HeaderToolbar 
    				header={I18n.t("appearance")} 
    				buttonsProps={[
    					{ text:I18n.t("cancel"), onClick:this.onCancelPress.bind(this) }, 
    					{ text:I18n.t("save"), onClick:this.onSavePress.bind(this) }
    				]} />
    			<ContainerLoading isLoading={this.state.isLoading} >
    				<Row type="flex" justify='center'>
    					<Col span={20}>
    						<Row type='flex' align='middle'>
    							<Col xs ={24} md= {12} style={{
    								display:"flex",
    								justifyContent:"flex-end",
    								paddingRight:32,
    							}}>
    								<UploadImage setRef={(ref)=>{this.inputs.uploadImageInput=ref;}}
    									src={this.state.bannerSRC}
    									onFileLoaded={this.onImageFileLoaded.bind(this)}
    								/>
    							</Col>
    							<Col xs ={24} md= {12} >
    								<Form>
    									<OForm.InlineItem>
    										<ColumnLabel>{`${I18n.t("cooperate_name.label")}:`}</ColumnLabel>
    										<Col>
    											{getFieldDecorator(this.FormFields.NAME,{
    												initialValue:this.state.name,
    												rules:[{
    													required:true,
    													message: I18n.t("cooperate_name.require_warning"),
    												}]
    											})(
    												<Input placeholder={`${I18n.t("cooperate_name.placeholder")}`} 
    													onChange={this.onNameChanged.bind(this)}
    												/>
    											)}
    										</Col>
    									</OForm.InlineItem>
    									<OForm.Item>
    										<ColumnLabel>{`${I18n.t("cooperate_color.label")}:`}</ColumnLabel>
    										<ColorSelection colors={ColorLists} 
    											selectColor = {this.state.color} 
    											onSelected={this.onColorSelected.bind(this)} />
    									</OForm.Item>
    									<OForm.InlineItem>
    										{/* <ColorSquare color={this.state.color} /> */}
    										{getFieldDecorator(this.FormFields.COLOR,{
    											initialValue:noSharpColor,
    											rules:[{
    												required:true,
    												message: I18n.t("cooperate_color.require_warning"),
    											}]
    										})(<ColorInput 
    											ref={ref=>{this.inputs.colorInput = ref;}} 
    											onChange={this.onCustomColorChanged.bind(this)}
    											onPressEnter={this.onPreviewPress.bind(this)}
    										/>)}
    										<OButton onClick={this.onPreviewPress.bind(this)}>{I18n.t("preview")}</OButton>
    									</OForm.InlineItem>
    								</Form>
    							</Col>
    						</Row>
    					</Col>
    				</Row>
    			</ContainerLoading>
    		</ContentBox.Box>
    	);
    }
}
AppearancePanel.contextTypes = {
	updateThemes: PropTypes.func,
	updatePreviewTheme: PropTypes.func,
	clearPreviewTheme: PropTypes.func,
};
export default Form.create()(AppearancePanel);


// WEBPACK FOOTER //
// ./src/containers/SettingPanels/Appearance.js